import { Tabs, TabsList, TabsTrigger } from "../../shadcn/Tabs";
import { Plus, Minus } from "lucide-react";
import ToolbarButton from "../../SearchListings/ToolbarButton";
import MyLocationToolbarButton from "../../common/maps/MyLocationToolbarButton";
import { MapTypeId } from "../Map";
import { GeoLocation } from "../../../types/common";

interface BasicToolbarProps {
  mapTypeId: MapTypeId;
  onMapTypeChange: (mapTypeId: MapTypeId) => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onLocationRequest?: (location: GeoLocation) => void;
}

export const BasicToolbar = ({
  mapTypeId,
  onMapTypeChange,
  onZoomIn,
  onZoomOut,
  onLocationRequest,
}: BasicToolbarProps) => {
  return (
    <div className="basic-toolbar flex flex-col items-start gap-2">
      <div className="flex flex-col gap-1">
        <ToolbarButton
          onClick={onZoomIn}
          icon={<Plus className="h-4 w-4" />}
          title="Zoom In"
          className="bg-white"
        />
        <ToolbarButton
          onClick={onZoomOut}
          icon={<Minus className="h-4 w-4" />}
          title="Zoom Out"
          className="bg-white"
        />
        <MyLocationToolbarButton
          onClick={(location) => onLocationRequest?.(location)}
          className="bg-white"
        />
      </div>
      <Tabs
        value={mapTypeId}
        onValueChange={(value) => onMapTypeChange(value as MapTypeId)}
      >
        <TabsList>
          <TabsTrigger value={MapTypeId.Roadmap}>
            Map
          </TabsTrigger>
          <TabsTrigger value={MapTypeId.Satellite}>
            Satellite
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};